import {Boundary} from "./boundary";
import {Vector3} from "three";
import {HBEWallDefaultThickness} from "../../../../globals";
import {toFixedFloat} from "../../../../utils/utils";

export class Wall extends Boundary {
    constructor(sceneObject) {
        super(sceneObject);

        //Verlängern der BoundingBox für Wände. Für Unterzüge ist dies nicht nötig, weil diese bereits auf den Wänden aufliegen
        let expandVector = new Vector3(0, 0, 0);
        if (this.orientation === "x") {
            expandVector.setX(HBEWallDefaultThickness);
        } else {
            expandVector.setZ(HBEWallDefaultThickness);
        }

        this.boundingBox = this.boundingBox.expandByVector(expandVector);

        this.boundingBox.min.setX(toFixedFloat(this.boundingBox.min.x));
        this.boundingBox.max.setX(toFixedFloat(this.boundingBox.max.x));
        this.boundingBox.min.setZ(toFixedFloat(this.boundingBox.min.z));
        this.boundingBox.max.setZ(toFixedFloat(this.boundingBox.max.z));
    }
}
